import { LocationAddressPropertyType } from '../api/models'

export const PropertyTypeDisplayNames: Record<LocationAddressPropertyType, string> = {
  [LocationAddressPropertyType.Apartment]: 'Apartment',
  [LocationAddressPropertyType.House]: 'House',
  [LocationAddressPropertyType.Commercial]: 'Business'
}
